// components/users/UserFilters.tsx
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import {
  Search,
  Users as UsersIcon,
  Shield,
  Briefcase,
  Headset,
} from "lucide-react";

interface UserFiltersProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  roleStatistics: {
    totalUsers: number;
    admins: number;
    sales: number;
    support: number;
  };
}

export function UserFilters({
  searchQuery,
  onSearchChange,
  roleStatistics,
}: UserFiltersProps) {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <Card>
          <CardContent className="p-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-xs text-slate-600">Total Usuarios</p>
                <p className="text-2xl font-bold text-slate-900">
                  {roleStatistics.totalUsers}
                </p>
              </div>
              <UsersIcon className="h-8 w-8 text-blue-500" />
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-xs text-slate-600">Administradores</p>
                <p className="text-2xl font-bold text-purple-600">
                  {roleStatistics.admins}
                </p>
              </div>
              <Shield className="h-8 w-8 text-purple-500" />
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-xs text-slate-600">Ventas</p>
                <p className="text-2xl font-bold text-green-600">
                  {roleStatistics.sales}
                </p>
              </div>
              <Briefcase className="h-8 w-8 text-green-500" />
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-xs text-slate-600">Soporte</p>
                <p className="text-2xl font-bold text-orange-600">
                  {roleStatistics.support}
                </p>
              </div>
              <Headset className="h-8 w-8 text-orange-500" />
            </div>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardContent className="p-4">
          <div className="flex flex-col md:flex-row gap-4">
            <div className="relative flex-1">
              <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
              <Input
                placeholder="Buscar por nombre, email o teléfono..."
                value={searchQuery}
                onChange={(e) => onSearchChange(e.target.value)}
                className="pl-10"
              />
            </div>
          </div>
        </CardContent>
      </Card>
    </>
  );
}
